export default "__VITE_ASSET__DhCb4YjU__"